import TransferenciasJugadoresSelector from './views/TransferenciasJugadoresSelector.vue'
import TransferenciasJugadoresListView from './views/TransferenciasJugadoresListView.vue'
import TransferenciasCedidosJugadoresListView from './views/TransferenciasCedidosJugadoresListView.vue'

export default [
  {
    path: '/selector-transferencias',
    name: 'selector-transferencias',
    component: TransferenciasJugadoresSelector,
    children: [
      {
        path: 'transferencias',
        name: 'finalizados-transferencias',
        component: TransferenciasJugadoresListView
      },
      {
        path: 'cedidos',
        name: 'cedidos',
        component: TransferenciasCedidosJugadoresListView
      }
    ]
  }
]
